import { Link } from "gatsby";
import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";

// import { AnnouncementBanner } from "../homepagenew/AnnouncementBanner";
import { trackGAEvents } from "../common/trackGA";
import "./hasuraconheader.scss";

// const brandWhite = require("./images/hasura-logo.svg")
// const brandWhite = require("../../images/white-logo.svg")
import brandBlue from "../../images/blue-logo.svg";
import closeIcon from "../homepagenew/images/close-banner.svg";
// const twitterHeader = require('./images/twitter-header.svg');
function openMenuBar() {
  var x = document.getElementById("navbar");
  if (x.className === "topnav") {
    x.className += " responsive";
    document.body.style.overflow = "hidden";
    document.getElementById("viewport").style.overflow = "hidden";
  }
}

function closeMenuBar() {
  var x = document.getElementById("navbar");
  if (x.className === "topnav responsive") {
    x.className = "topnav";
    document.body.style.overflow = null;
    document.getElementById("viewport").style.overflow = null;
  }
}

const HasuraConHeader = props => {
  const wrapperRef = useRef(null);
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);
  const handleClickOutside = event => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      var x = document.getElementById("navbar");
      if (x.className === "topnav responsive") {
        x.className = "topnav";
        document.body.style.overflow = null;
        document.getElementById("viewport").style.overflow = null;
      }
    }
  };

  return (
    <div>
      {/* <AnnouncementBanner /> */}
      <header id="hasura-con-header" className={"hasuraConBoxShadow headerFixed topHeaderShow"}>
        <div className=" containerWidth">
          <div className="hasuraConHeaderWrapper">
            <div className="navLeft flexOne">
              <div className="brand">
                <a href="/">
                  <img src={brandBlue} alt="Hasura Logo" title="Hasura Logo" />
                </a>
              </div>
            </div>
            <div className="navWhiteBG">
              <ul className="navBarUL">
                <li>
                  <Link
                    onClick={() => {
                      trackGAEvents("HasuraCon", "HeaderClick", "Speakers");
                    }}
                    to="/events/hasura-con-2020/speakers/"
                  >
                    Speakers
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={() => {
                      trackGAEvents("HasuraCon", "HeaderClick", "Agenda");
                    }}
                    to="/events/hasura-con-2020/talks/"
                  >
                    Agenda
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={() => {
                      trackGAEvents("HasuraCon", "HeaderClick", "CodeOfConduct");
                    }}
                    to="/events/hasura-con-2020/code-of-conduct/"
                  >
                    Code of Conduct
                  </Link>
                </li>
                <li className="registerLink">
                  <a
                    href="https://www.youtube.com/playlist?list=PLTRTpHrUcSB9BmfyXmhplz874ySHeKlYx"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="commonBtnCon hasuraConNavBtn">Watch Talks</button>
                  </a>
                </li>
              </ul>
            </div>
            <div id="navbar" className="topnav" ref={wrapperRef}>
              <div className={"navWhiteBG"}>
                {/*eslint-disable-next-line*/}
                <span
                  className="navBarToggle"
                  aria-label="button"
                  role="button"
                  tabIndex="0"
                  onClick={() => openMenuBar()}
                  id="menuClick"
                >
                  <span className={"iconBar"}></span>
                  <span className={"iconBar"}></span>
                  <span className={"iconBar"}></span>
                </span>
              </div>
              <div className="visibleMobile">
                <div className="menuBarViewHasuraCon">
                  <div className="navBarStripe">
                    <Link to="/cloud/">
                      <span role="img" aria-label="emoji">
                        👋
                      </span>
                      <br />
                      Announcing Hasura Cloud: the managed service to access your data via GraphQL
                      instantly
                    </Link>
                    {/*eslint-disable-next-line*/}
                    <div
                      className="closeNavBar"
                      role="button"
                      tabIndex="0"
                      onClick={() => closeMenuBar()}
                      id="closeMenu"
                    >
                      <img className={"img-responsive"} src={closeIcon} alt="Close" />
                    </div>
                  </div>
                  <ul className="navBarULMobile">
                    <li>
                      <Link
                        onClick={() => {
                          trackGAEvents("HasuraCon", "HeaderClickMobile", "Speakers");
                        }}
                        to="/events/hasura-con-2020/speakers/"
                      >
                        Speakers
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() => {
                          trackGAEvents("HasuraCon", "HeaderClickMobile", "Agenda");
                        }}
                        to="/events/hasura-con-2020/talks/"
                      >
                        Agenda
                      </Link>
                    </li>
                    <li className="fullWidth registerLink">
                      <a
                        onClick={() => {
                          trackGAEvents("HasuraCon", "HeaderClickMobile", "Talks");
                        }}
                        href="https://www.youtube.com/playlist?list=PLTRTpHrUcSB9BmfyXmhplz874ySHeKlYx"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <button className="commonBtnCon hasuraConNavBtn">Watch Talks</button>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

HasuraConHeader.propTypes = {
  location: PropTypes.object,
};

export default HasuraConHeader;
